import { useEffect } from "react";

const sections = [
  {
    id: "overview",
    title: "1. Overview",
    body: "Aardvarks Vault (\"we\", \"us\", \"the Vault\") is a Texas-based online collectibles business. This Privacy Policy explains what information we collect when you use our website or submit a collection for an offer, and how we use it.",
  },
  {
    id: "information-we-collect",
    title: "2. Information We Collect",
    body: "When you submit a seller form or contact form, we collect the details you provide: your name, email address or phone number, collection type, approximate size or value, location, description, and any photos or card lists you upload. We also receive standard technical data (such as browser type and pages visited) that most websites collect for performance and security.",
  },
  {
    id: "how-we-use",
    title: "3. How We Use Your Information",
    body: "We use your information solely to evaluate your collection, prepare and communicate an offer, arrange insured shipping and payment if you accept, respond to your inquiries, and keep our records in order. Submissions are delivered directly to ashton@aardvarksvault.com.",
  },
  {
    id: "uploads",
    title: "4. Photos & Card List Uploads",
    body: "Files you upload are stored securely on our servers and used only to appraise your collection. They are never published, sold, or shared with third parties beyond what is required to complete a transaction you approve.",
  },
  {
    id: "sharing",
    title: "5. Sharing & Third Parties",
    body: "We do not sell, rent, or trade your personal information. Limited data may be processed by service providers that operate the website, email delivery, shipping carriers (for labels you approve), and payment services (for payouts you request) — only as needed to provide those services.",
  },
  {
    id: "retention",
    title: "6. Data Retention",
    body: "We keep submission records only as long as needed to evaluate your collection, complete any transaction, and meet legal or accounting obligations. You may request deletion of your submission data at any time by emailing ashton@aardvarksvault.com.",
  },
  {
    id: "security",
    title: "7. Security",
    body: "We apply reasonable technical and organizational safeguards to protect your information, including encrypted transport (HTTPS) and restricted access to submission records. No method of transmission over the internet is 100% secure, but protecting seller information is a core Vault promise.",
  },
  {
    id: "your-rights",
    title: "8. Your Rights",
    body: "You may request access to, correction of, or deletion of the personal information we hold about you by contacting ashton@aardvarksvault.com. We will respond to verified requests within a reasonable timeframe.",
  },
  {
    id: "children",
    title: "9. Children's Privacy",
    body: "Our services are directed to adults. We do not knowingly collect personal information from children under 13. If you believe a child has submitted information to us, contact us and we will delete it.",
  },
  {
    id: "changes",
    title: "10. Changes & Contact",
    body: "We may update this policy from time to time; the current version is always posted on this page. Questions about privacy can be sent to ashton@aardvarksvault.com. Aardvarks Vault is based in Texas, USA, and serves sellers nationwide.",
  },
];

const Privacy = () => {
  useEffect(() => {
    document.title = "Privacy Policy — Aardvarks Vault";
  }, []);

  return (
    <div className="px-5 pb-24 pt-40 sm:px-8" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 font-serif text-3xl font-bold tracking-tight text-cream sm:text-4xl lg:text-5xl" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cream/50">
          Aardvarks Vault · Texas, USA · Last updated July 2026
        </p>
        <nav className="mt-10 flex flex-wrap gap-2" aria-label="Policy sections">
          {sections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              data-testid={`privacy-jump-${s.id}`}
              className="rounded-full border border-gold/25 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-cream/60 transition-colors hover:border-gold hover:text-gold"
            >
              {s.title.split(". ")[1]}
            </a>
          ))}
        </nav>
        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28 border-l-2 border-gold/25 pl-6" data-testid={`privacy-section-${s.id}`}>
              <h2 className="font-serif text-xl font-semibold text-gold">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-cream/75">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Privacy;
